import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * XP setting for auto-filling the email address in the FD signup modal for users coming from a brand-sent email
 * https://www.notion.so/faire/Auto-fill-emails-on-signup-1812efb5c25a80959912f0c21ae0c508
 */
export const FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128 = experiment({
  name: "FE_FAIRE_DIRECT_SIGNUP_EMAIL_AUTOFILL_250128",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-04-01",
  productArea: "FAIRE_DIRECT",
  defaultValue: false,
});
